import React, { forwardRef, useState } from 'react';
import { Input, Space } from 'antd';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import PropTypes from 'prop-types';

export const PasswordInput = forwardRef(({ 
  label,
  error, 
  helperText,
  required,
  layout,
  labelCol,
  wrapperCol,
  ...props 
}, ref) => {
  return (
    <InputWrapper
      label={label}
      error={error}
      helperText={helperText}
      required={required}
      layout={layout}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <Space.Compact style={{ width: '100%' }}>
        <Input.Password 
          status={error ? 'error' : ''} 
          {...props} 
          visibilityToggle={true}
          ref={ref}
        />
      </Space.Compact>
    </InputWrapper>
  );
});

PasswordInput.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  required: PropTypes.bool,
};

export default PasswordInput; 